import { SignalDoc } from "@megaron/docs-contracts";

import { withInvoiceDraftNameFallback } from "../history/getDocDisplayName";

export const getSignalDisplayName = (signal: SignalDoc): string =>
  withInvoiceDraftNameFallback(signal.name, signal.subjectDocType === "invoice-draft");
